import { Panel } from 'react-bootstrap'
import { IPendingSwap } from '@nkr/models/index';
import { FileDocumentType, PendingSwapsListType } from '@nkr/enums/index';
import { ICurrentTimeFrame, SwapsToShow } from '../models';
import { TableWrapper } from './styles'
import PendingSwapsRow from './pending-swaps-row';

interface IProps {
    list: IPendingSwap[],
    centerId: number,
    show: SwapsToShow,
    currentTimeframe: ICurrentTimeFrame,
    widths: string[],
    onRequestScreeningXm: (swap: IPendingSwap, existingXm: boolean, status: string) => void
    onRequestFinalXm: (swap: IPendingSwap, existingXm: boolean, status: string, isInternalOrRemote: boolean) => void,
    onEmergencyNotification: (swap: IPendingSwap) => void,
    onRequestSerologyKit: (swap: IPendingSwap, isInternalOrRemote: boolean) => void,
    onUploadFinalXm: (swap: IPendingSwap) => void,
    onUploadSerology: (swap: IPendingSwap) => void,
    onViewLogistics: (swap: IPendingSwap) => void,
    onShowMap: (url: string) => void,
    onShowGps: (link: string) => void,
    onViewCustomLogistics: (chainId: number, clusterNumber: number, positionNumber: number) => void
    onGetFinalXmResults: (recipientId: number, donorId: number, fileName: string) => void,
    onDownloadFormsAndChecklists: (donorId: number, recipientId: number) => void,
    onGetFile: (docType: FileDocumentType, donorId: number) => void,
    onGetPatientOutcomes: (centerId: number) => void,
    onViewCtScan: (donorId: number) => void
}

const Patients = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading style={{ fontSize: 16, fontWeight: 600 }}>
                Patients
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper condensed>
                    <thead>
                        <tr style={{ backgroundColor: '#ddd' }}>
                            <th style={{ width: props.widths[0] }}>Swap Manager</th>
                            <th style={{ width: props.widths[0] }}>Swap Status</th>
                            <th style={{ width: props.widths[1] }}>Swap #</th>
                            <th style={{ width: props.widths[2] }}>R Type</th>
                            <th>Donor<br />Center</th>
                            <th>Donor<br />Alias</th>
                            <th>Patient<br />Center</th>
                            <th>Patient<br />Alias</th>
                            <th>Eplet MM<br />Risk</th>
                            <th>Allele<br />Match</th>
                            <th style={{ width: props.widths[6] }}><span style={{ color: '#63a7ff' }}>Logistics</span> &amp;<br /> <span style={{ color: '#ff993d' }}>Kickoff</span> Calls</th>
                            <th style={{ width: props.widths[7] }}>Tubes for<br />Transport</th>
                            <th style={{ width: props.widths[8] }}>Logistics/GPS</th>
                            <th style={{ width: props.widths[11] }}>Scheduled<br />Delivery</th>

                            {props.show == SwapsToShow.Pending && (
                                <th style={{ width: props.widths[12] }}>Deadline</th>
                            )}

                            {props.show == SwapsToShow.Past && (
                                <th style={{ width: props.widths[12] }}>Actual<br />Delivery</th>
                            )}

                            <th style={{ width: props.widths[13] }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((swap, index) =>
                            <PendingSwapsRow
                                key={index}
                                index={index}
                                centerId={props.centerId}
                                data={swap}
                                type={PendingSwapsListType.Recipient}
                                widths={props.widths}
                                show={props.show}
                                onRequestScreeningXm={props.onRequestScreeningXm}
                                onRequestFinalXm={props.onRequestFinalXm}
                                onEmergencyNotification={props.onEmergencyNotification}
                                onRequestSerologyKit={props.onRequestSerologyKit}
                                onViewLogistics={props.onViewLogistics}
                                onShowGps={props.onShowGps}
                                onShowMap={props.onShowMap}
                                onUploadFinalXm={props.onUploadFinalXm}
                                onUploadSerology={props.onUploadSerology}
                                onViewCustomLogistics={props.onViewCustomLogistics}
                                onGetFinalXmResults={props.onGetFinalXmResults}
                                onDownloadFormsAndChecklists={props.onDownloadFormsAndChecklists}
                                onGetFile={props.onGetFile}
                                onGetPatientOutcomes={props.onGetPatientOutcomes}
                                onViewCtScan={props.onViewCtScan}
                            />
                        )}

                        {props.list.length == 0 && props.show == SwapsToShow.Pending && (
                            <tr>
                                <td colSpan={15}>There are no recipients at this time...</td>
                            </tr>
                        )}

                        {props.list.length == 0 && props.show == SwapsToShow.Past && (
                            <tr>
                                <td colSpan={15}>There are no recipients for the {props.currentTimeframe.title.toLowerCase()}...</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default Patients;